import React from 'react';

function SimpleFamilyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={48}
      height={41}
      viewBox="0 0 48 41"
      fill="none">
      <path
        d="M36.0025 18.3189C36.0025 15.2429 34.7808 13.5023 31.9603 13.0317V12.0645H28.9514V13.0317C26.1309 13.5023 24.9156 15.2429 24.9156 18.3189L23.1133 26.8652L25.1171 27.3662L27.0515 17.9464C27.0515 15.5588 27.9917 15.7875 30.2901 15.8006L30.2858 15.8311C32.6903 15.8267 33.8753 15.5087 33.8753 17.9464L35.8141 27.3662L37.8049 26.8652L35.9982 18.3189H36.0025Z"
        fill="#FFC99C"
      />
      <path
        d="M30.6458 38.6996L32.3961 38.5798L33.2215 27.0098L30.4941 27.0729C30.6869 30.5259 30.6609 37.5646 30.6458 38.6996Z"
        fill="#FFC99C"
      />
      <path
        d="M30.043 38.5798C30.0278 37.4448 29.9671 30.5259 30.1599 27.0729L27.4326 27.0098L28.258 38.5798H30.043Z"
        fill="#FFC99C"
      />
      <path
        d="M35.5321 7.39712C35.5321 10.2989 32.8958 12.6517 30.4458 12.6517C27.9957 12.6517 25.3594 10.2989 25.3594 7.39712C25.3594 4.49536 27.6361 2.14258 30.4458 2.14258C33.2554 2.14258 35.5321 4.49536 35.5321 7.39712Z"
        fill="#FFC99C"
      />
      <path
        d="M24.6184 27.8284C24.4992 28.3012 24.0227 28.5887 23.5526 28.4689C23.0825 28.3491 22.7966 27.8698 22.9157 27.3971L23.2017 26.2556C23.3186 25.7828 23.7974 25.4953 24.2675 25.6151C24.7375 25.7349 25.0235 26.2142 24.9043 26.6869L24.6184 27.8284Z"
        fill="#FFC99C"
      />
      <path
        d="M36.3081 27.8284C36.4272 28.3012 36.9038 28.5887 37.3739 28.4689C37.844 28.3491 38.1299 27.8698 38.0108 27.3971L37.7248 26.2556C37.6057 25.7828 37.1291 25.4953 36.659 25.6151C36.189 25.7349 35.903 26.2142 36.0221 26.6869L36.3081 27.8284Z"
        fill="#FFC99C"
      />
      <path
        d="M30.0788 38.5352V39.6702H26.8836C26.4395 39.6702 26.7601 39.3543 27.2367 39.1255C28.127 38.6985 28.2592 38.5809 28.2592 38.5809L30.081 38.5352H30.0788Z"
        fill="#433934"
      />
      <path
        d="M30.6455 38.5352V39.6702H33.8884C34.3325 39.6702 34.0119 39.3543 33.5353 39.1255C32.645 38.6985 32.4912 38.5809 32.4912 38.5809L30.6477 38.5352H30.6455Z"
        fill="#433934"
      />
      <path
        d="M32.1491 5.11608C32.1491 5.11608 30.5504 7.17259 28.9539 7.64532L29.1423 6.82185C29.1423 6.82185 28.0137 7.81089 27.0735 8.28362V7.90456C27.0735 7.90456 25.9449 9.5123 26.7919 11.2137C26.7919 11.2137 24.4415 9.13324 25.1932 6.10948C25.9449 3.08572 27.9184 2.3276 29.1423 1.85487L28.5986 1.55641C28.5986 1.55641 31.3042 1.28846 32.7145 2.3276C32.7145 2.3276 34.4063 2.23393 35.3465 5.06815C36.2866 7.90238 35.535 9.69965 34.4995 10.9305C34.4995 10.9305 34.4063 7.88931 33.5593 6.80878C32.7123 5.73042 32.1491 5.11608 32.1491 5.11608Z"
        fill="#433934"
      />
      <path
        d="M26.9775 24.4473L28.1062 37.3527L30.032 37.4464L30.4067 26.0071L30.6537 37.3048L32.482 37.3505L34.1002 24.5431L26.9775 24.4473Z"
        fill="#CD232E"
      />
      <path
        d="M33.8311 17.147C33.4607 15.694 33.8311 13.6702 33.8311 13.6702L32.54 13.1016C32.5075 14.7442 30.3911 15.6286 30.3911 15.6286C30.3911 15.6286 28.3071 14.7442 28.2746 13.1016L27.0009 13.6702C27.0009 13.6702 27.38 15.6918 27.0095 17.147L26.1582 24.604C26.1582 24.604 27.6789 25.1726 30.3911 25.1726C33.1032 25.1726 34.6521 24.604 34.6521 24.604L33.8289 17.147H33.8311Z"
        fill="#17385D"
      />
      <path
        opacity="0.4"
        d="M46.5917 39.5122C46.5917 39.898 36.567 40.2119 24.2006 40.2119C11.8343 40.2119 1.80957 39.8999 1.80957 39.5122C1.80957 39.1245 11.8343 38.8125 24.2006 38.8125C36.567 38.8125 46.5917 39.1245 46.5917 39.5122Z"
        fill="#BCB297"
      />
      <path
        d="M22.9566 6.46811C22.9566 9.40473 20.2878 11.7858 17.8074 11.7858C15.327 11.7858 12.6582 9.40473 12.6582 6.46811C12.6582 3.53149 14.9631 1.15039 17.8074 1.15039C20.6517 1.15039 22.9566 3.53149 22.9566 6.46811Z"
        fill="#FFC99C"
      />
      <path
        d="M19.2655 11.4043H16.2197V12.9358H19.2655V11.4043Z"
        fill="#FFC99C"
      />
      <path
        d="M17.799 12.553H17.7492C13.9019 12.553 11.7703 14.494 11.7703 18.363L10.5117 27.1446V28.2992C10.5117 28.8198 10.945 29.2425 11.4627 29.2425C11.9804 29.2425 12.4137 28.8198 12.4137 28.2992V27.6718H12.9379L13.551 22.5152L13.8088 18.0014C13.8088 15.4024 15.1735 15.2979 17.7557 15.2979L17.7904 15.4133C20.3747 15.4133 21.7373 15.3393 21.7373 17.9382L22.6081 27.6718H22.8789V28.2992C22.8789 28.8198 23.3122 29.2425 23.8299 29.2425C24.3476 29.2425 24.7809 28.8198 24.7809 28.2992V27.8787L24.7939 27.2012L23.4811 18.3826C23.4811 14.5136 21.6441 12.5508 17.7969 12.5508L17.799 12.553Z"
        fill="#FFC99C"
      />
      <path
        d="M14.2139 23.2715L14.7338 38.5188L16.3151 38.5014L17.7232 26.8203L19.1703 38.582H20.7148L21.343 23.2715H14.2139Z"
        fill="#17385D"
      />
      <path
        d="M17.7992 14.7095C17.7992 14.7095 16.259 12.64 16.2178 12.6465C13.8674 13.0212 12.4247 14.4873 11.9871 16.7878C11.8918 17.2845 10.6592 26.7174 10.6592 26.7174H13.1071L14.1339 18.8835L14.1642 25.1162L21.3367 25.2121L21.5165 19.0709L22.513 26.7196H24.872C24.872 26.7196 23.5788 16.7443 23.3643 16.0624C22.7902 14.239 21.458 13.0016 19.4217 12.6509L17.7948 14.7117L17.7992 14.7095Z"
        fill="#89C3F1"
      />
      <path
        d="M16.3258 38.5021L16.289 39.733H12.7212C12.2273 39.733 12.5825 39.343 13.1133 39.0881C14.1011 38.6132 14.7943 38.4629 14.7943 38.4629L16.3258 38.5021Z"
        fill="#AF6617"
      />
      <path
        d="M19.1504 38.5L19.1937 39.7309H22.9197C23.4353 39.7309 23.0627 39.4084 22.5103 39.1427C21.4813 38.6481 20.6841 38.5327 20.6841 38.5327L19.1504 38.5Z"
        fill="#AF6617"
      />
      <path
        d="M20.6233 8.8947C19.6399 8.95569 18.8405 7.90566 17.8592 7.90566C16.8779 7.90566 16.0764 8.95569 15.095 8.8947C14.1116 8.8337 13.2342 7.55056 12.6602 6.64648L12.6905 6.76194C12.6905 8.43068 13.7585 10.424 14.9412 11.2257C16.124 12.0296 16.7544 12.169 17.8614 12.169C18.9683 12.169 19.5965 12.0296 20.7815 11.2257C21.9643 10.4218 23.0322 8.4285 23.0322 6.76194L23.0625 6.64648C22.4863 7.55056 21.609 8.8337 20.6277 8.8947H20.6233ZM17.7422 9.94691C17.1703 9.94691 15.8381 9.02105 17.7422 9.02105C19.8348 9.02105 18.5026 9.94691 17.7422 9.94691Z"
        fill="#E09000"
      />
      <path
        d="M12.6583 6.23757C12.6583 6.23757 14.7293 3.94143 15.0455 2.91971C15.0455 2.91971 20.2186 4.0046 21.3429 3.49483C21.3429 3.49483 22.7661 6.01318 23.0282 6.76476C23.0282 6.76476 23.2275 3.88914 21.9602 2.4753C21.9602 2.4753 22.4087 1.90017 22.3415 1.07234C22.3415 1.07234 20.8165 1.58211 19.7398 0.688926C18.661 -0.204259 15.7712 -0.435181 14.8549 1.26405C14.8549 1.26405 12.1102 2.79554 12.6583 6.23975V6.23757Z"
        fill="#E09000"
      />
      <path
        d="M9.80007 24.0313C9.80007 21.7417 8.73861 20.4476 6.83446 20.0969V19.4434H4.36059V20.0969C2.45645 20.4476 1.43397 21.7439 1.43397 24.0313L0.129883 30.3925L1.63977 30.765L3.089 23.7546C3.089 21.9791 3.79086 22.1491 5.50438 22.1578V22.1817C7.21789 22.1796 8.17754 21.9421 8.17754 23.7546L9.62244 30.765L11.1258 30.3925L9.80224 24.0313H9.80007Z"
        fill="#FFC99C"
      />
      <path
        d="M5.77085 39.1988L7.07277 39.1094L7.68799 30.5L5.6582 30.5457C5.80118 33.1142 5.78168 38.3535 5.77085 39.1988Z"
        fill="#FFC99C"
      />
      <path
        d="M5.32497 39.1094C5.31414 38.2642 5.26865 33.1164 5.41162 30.5457L3.38184 30.5L3.99705 39.1094H5.32497Z"
        fill="#FFC99C"
      />
      <path
        d="M10.1299 15.3473C10.1299 17.9201 7.79251 20.0071 5.61975 20.0071C3.44698 20.0071 1.10742 17.9201 1.10742 15.3473C1.10742 12.7745 3.12638 10.6875 5.61975 10.6875C8.11311 10.6875 10.1299 12.7723 10.1299 15.3473Z"
        fill="#FFC99C"
      />
      <path
        d="M1.28663 31.1067C1.19781 31.4596 0.84471 31.6731 0.493775 31.5838C0.145007 31.4945 -0.0672871 31.1394 0.0193633 30.7865L0.231657 29.9369C0.320474 29.5839 0.673574 29.3705 1.02451 29.4598C1.37328 29.5491 1.58774 29.9042 1.49892 30.2571L1.28663 31.1067Z"
        fill="#FFC99C"
      />
      <path
        d="M9.98569 31.1067C10.0745 31.4596 10.4276 31.6731 10.7785 31.5838C11.1295 31.4945 11.3396 31.1394 11.253 30.7865L11.0407 29.9369C10.9518 29.5839 10.5987 29.3705 10.2478 29.4598C9.89687 29.5491 9.68675 29.9042 9.7734 30.2571L9.98569 31.1067Z"
        fill="#FFC99C"
      />
      <path
        d="M8.18412 24.8772L10.0124 24.8336C10.0124 24.8336 9.85647 23.3762 9.58135 22.2543C9.17626 20.6008 7.41509 20.2305 7.41509 20.2305C7.41509 20.2305 7.12265 21.775 5.63659 21.8033C4.15054 21.775 3.85809 20.2305 3.85809 20.2305C3.85809 20.2305 2.09475 20.6008 1.69183 22.2543C1.41671 23.3784 1.26074 24.8315 1.26074 24.8315L3.08907 24.8772L3.0934 27.267C1.94528 29.4433 1.3214 32.3756 1.3214 32.3756C1.3214 32.3756 1.44704 33.2797 5.64959 33.2797C9.85214 33.2797 9.97561 32.3756 9.97561 32.3756C9.97561 32.3756 9.3409 29.4041 8.17978 27.2235L8.18412 24.8794V24.8772Z"
        fill="#CD232E"
      />
      <path
        d="M5.31126 39.0762V39.9214H2.9717C2.64026 39.9214 2.87855 39.6862 3.23598 39.5162C3.89886 39.1982 3.97684 39.111 3.97684 39.111L5.31343 39.0783L5.31126 39.0762Z"
        fill="#AF6617"
      />
      <path
        d="M5.69238 39.0762V39.9214H7.99295C8.32439 39.9214 8.0861 39.6862 7.72867 39.5162C7.06579 39.1982 7.05929 39.1088 7.05929 39.1088L5.69238 39.0783V39.0762Z"
        fill="#AF6617"
      />
      <path
        d="M7.21511 12.9349C7.21511 12.9349 4.217 15.2311 3.07538 14.8956C1.93376 14.5601 2.36268 14.1789 2.36268 14.1789C2.36268 14.1789 1.43552 17.7647 2.81543 19.8713C2.81543 19.8713 -0.206507 18.1503 1.1734 13.8456C2.12872 10.861 5.4561 9.97 7.50105 10.8784C7.50105 10.8784 8.4997 10.8305 9.49835 12.0265C10.497 13.2225 11.8747 16.9543 8.95028 19.7297C8.95028 19.7297 9.83195 17.5773 9.30771 16.2855C9.30771 16.2855 7.45123 14.754 7.21511 12.9371V12.9349Z"
        fill="#E09000"
      />
      <path
        d="M46.5305 23.8399C46.5305 21.5503 45.4691 20.2562 43.5649 19.9055V19.252H41.0911V19.9055C39.1869 20.2562 38.1644 21.5524 38.1644 23.8399L36.8604 30.2011L38.3702 30.5736L39.8195 23.5632C39.8195 21.7877 40.5213 21.9576 42.2348 21.9664V21.9903C43.9484 21.9881 44.908 21.7507 44.908 23.5632L46.3529 30.5736L47.8563 30.2011L46.5327 23.8399H46.5305Z"
        fill="#FFC99C"
      />
      <path
        d="M42.5003 39.0073L43.8023 38.918L44.4175 30.3086L42.3877 30.3543C42.5307 32.9228 42.5112 38.1621 42.5003 39.0073Z"
        fill="#FFC99C"
      />
      <path
        d="M42.0525 38.918C42.0417 38.0728 41.9962 32.925 42.1392 30.3543L40.1094 30.3086L40.7246 38.918H42.0525Z"
        fill="#FFC99C"
      />
      <path
        d="M46.8594 15.1598C46.8594 17.7326 44.522 19.8196 42.3492 19.8196C40.1765 19.8196 37.8369 17.7326 37.8369 15.1598C37.8369 12.587 39.8559 10.5 42.3492 10.5C44.8426 10.5 46.8594 12.5848 46.8594 15.1598Z"
        fill="#FFC99C"
      />
      <path
        d="M38.0142 30.9173C37.9253 31.2702 37.5722 31.4837 37.2213 31.3944C36.8725 31.305 36.6603 30.9499 36.7469 30.597L36.9592 29.7474C37.048 29.3945 37.4011 29.181 37.752 29.2703C38.1008 29.3596 38.3153 29.7147 38.2265 30.0676L38.0142 30.9173Z"
        fill="#FFC99C"
      />
      <path
        d="M46.7132 30.9173C46.802 31.2702 47.1551 31.4837 47.5061 31.3944C47.857 31.305 48.0671 30.9499 47.9805 30.597L47.7682 29.7474C47.6794 29.3945 47.3263 29.181 46.9753 29.2703C46.6244 29.3596 46.4143 29.7147 46.5009 30.0676L46.7132 30.9173Z"
        fill="#FFC99C"
      />
      <path
        d="M44.9117 24.6897L46.74 24.6461C46.74 24.6461 46.584 23.1887 46.3089 22.0668C45.9038 20.4133 44.1426 20.043 44.1426 20.043C44.1426 20.043 43.8502 21.5875 42.3641 21.6158C40.8781 21.5875 40.5856 20.043 40.5856 20.043C40.5856 20.043 38.8223 20.4133 38.4194 22.0668C38.1443 23.1909 37.9883 24.644 37.9883 24.644L39.8166 24.6897L39.8209 27.0795C38.6728 29.2558 38.0489 32.1881 38.0489 32.1881C38.0489 32.1881 38.1746 33.0922 42.3771 33.0922C46.5797 33.0922 46.7032 32.1881 46.7032 32.1881C46.7032 32.1881 46.0684 29.2166 44.9073 27.036L44.9117 24.6919V24.6897Z"
        fill="#89C3F1"
      />
      <path
        d="M42.0417 38.8867V39.732H39.7022C39.3707 39.732 39.609 39.4967 39.9665 39.3268C40.6293 39.0087 40.7073 38.9216 40.7073 38.9216L42.0439 38.8889L42.0417 38.8867Z"
        fill="#AF6617"
      />
      <path
        d="M42.4199 38.8867V39.732H44.7205C45.0519 39.732 44.8136 39.4967 44.4562 39.3268C43.7933 39.0087 43.7868 38.9194 43.7868 38.9194L42.4199 38.8889V38.8867Z"
        fill="#AF6617"
      />
      <path
        d="M43.3587 12.6472L39.0912 13.9914C39.0912 13.9914 38.9006 17.1502 39.5439 19.6838C39.5439 19.6838 36.522 17.9628 37.9019 13.6581C38.8572 10.6735 42.1846 9.7825 44.2296 10.6909C44.2296 10.6909 45.2282 10.643 46.2269 11.839C47.2255 13.035 48.3433 16.9585 45.4188 19.7339C45.4188 19.7339 46.2745 17.3898 46.0384 14.3269C46.0384 14.3269 45.265 14.0654 43.3609 12.6472H43.3587Z"
        fill="#AF6617"
      />
    </svg>
  );
}

export default SimpleFamilyIcon;
